import { render } from "./apLoader.vue?vue&type=template&id=16335eb0&scoped=true&ts=true"
import script from "./apLoader.vue?vue&type=script&lang=ts"
export * from "./apLoader.vue?vue&type=script&lang=ts"

import "./apLoader.vue?vue&type=style&index=0&id=16335eb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16335eb0"]])

export default __exports__